import React, { useState, useEffect } from 'react'
import { Offcanvas } from 'react-bootstrap'
import clsx from 'clsx'
import CreateRoomMaintenanceComponent from './create-reservation/CreateRoomMaintenanceComponent'
import CreateBookingComponentV4 from './create-reservation-v4/CreateBookingComponentV4'

interface CreateReservationProps {
    show: boolean
    onClose: () => void,
    startDate?: string,
    endDate?: string,
    roomTypeId?: string,
    roomId?: string,
    initialTab?: string
}

const CreateReservation: React.FC<CreateReservationProps> = ({ show, onClose, startDate, endDate, roomTypeId, roomId, initialTab }) => {
    const [mode, setMode] = useState(initialTab || 'booking');

    useEffect(() => {
        if (show) {
            setMode(initialTab || 'booking');
        }
    }, [show, initialTab]);

    const [isProcessing, setIsProcessing] = useState(false);

    const handleClose = () => {
        if (isProcessing) return;
        onClose();
    };

    return (
        <Offcanvas
            show={show}
            placement="end"
            onHide={handleClose}
            style={{ width: '100%' }}
            backdrop={isProcessing ? 'static' : true}
            keyboard={!isProcessing}
        >
            <Offcanvas.Header closeButton={!isProcessing}>
                <div className='d-flex gap-2'>
                    <Offcanvas.Title>Create Reservation</Offcanvas.Title>
                    <button
                        className={clsx('btn btn-outline-primary btn-sm', { active: mode === 'booking' })}
                        onClick={() => setMode('booking')}
                        disabled={isProcessing} // Nonaktifkan tombol saat proses berjalan
                    >
                        Booking
                    </button>
                    <button
                        className={clsx('btn btn-outline-primary btn-sm', { active: mode === 'maintenance' })}
                        onClick={() => setMode('maintenance')}
                        disabled={isProcessing} // Nonaktifkan tombol saat proses berjalan
                    >
                        Room Maintenance
                    </button>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {mode === 'booking' && (
                    // <CreateBookingComponent onClose={handleClose} startDate={startDate} endDate={endDate} roomTypeId={roomTypeId} roomId={roomId} />
                    <CreateBookingComponentV4
                        onClose={handleClose}
                        startDate={startDate}
                        endDate={endDate}
                        roomTypeId={roomTypeId}
                        roomId={roomId}
                        // BARU: Teruskan callback untuk memberitahu status
                        onProcessingChange={setIsProcessing}
                    />
                )}
                {mode === 'maintenance' && (
                    <CreateRoomMaintenanceComponent onClose={handleClose} startDate={startDate} endDate={endDate} roomTypeId={roomTypeId} roomId={roomId} />
                )}
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default CreateReservation